import { CALL_TYPE_ID, COMMERCE_PAYMENT_TYPE_ID, DEAL_TYPE_ID, PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'feed... Remove this comment to see the full error message
import FeedbackLoader from 'feedback-loader';
import { useSelectedObjectTypeId } from '../../objectTypeIdContext/hooks/useSelectedObjectTypeId';
import { useCachedTableRecordCount } from 'crm-index-ui/rewrite/products/hooks/useCachedTableRecordCount';
import { triggerWootricSurvey, PRODUCTS_SURVEY_ID } from 'crm-index-ui/utils/triggerWootricSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
const FeedbackSurveyLoader = () => {
  const objectTypeId = useSelectedObjectTypeId();
  const total = useCachedTableRecordCount();
  const shouldShowSurvey = objectTypeId === CALL_TYPE_ID || objectTypeId === COMMERCE_PAYMENT_TYPE_ID || objectTypeId === DEAL_TYPE_ID || objectTypeId === PRODUCT_TYPE_ID;
  if (!shouldShowSurvey) {
    return null;
  }
  if (objectTypeId === PRODUCT_TYPE_ID && total > 0) {
    // Only load the products survey if at least one product exists in their view
    triggerWootricSurvey(PRODUCTS_SURVEY_ID);
    return /*#__PURE__*/_jsx(FeedbackLoader, {});
  }

  // We don't want the Payments survey to load onClientLoad as we have a specific requirement
  // that needs to be met before the survey is shown
  if (objectTypeId === COMMERCE_PAYMENT_TYPE_ID || objectTypeId === DEAL_TYPE_ID) {
    return /*#__PURE__*/_jsx(FeedbackLoader, {});
  }
  return /*#__PURE__*/_jsx(FeedbackLoader, {
    clientLoadOnly: false
  });
};
export default FeedbackSurveyLoader;